"use client";

import { useEffect, useState } from "react";
import FingerprintJS from "@fingerprintjs/fingerprintjs";

// Module-level singleton — load the agent once per app session
let agentPromise: ReturnType<typeof FingerprintJS.load> | null = null;

function getAgentPromise() {
  if (!agentPromise) {
    agentPromise = FingerprintJS.load();
  }
  return agentPromise;
}

interface UseFingerprintResult {
  visitorId: string;
  isLoading: boolean;
}

export function useFingerprint(): UseFingerprintResult {
  const [visitorId, setVisitorId] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getAgentPromise()
      .then((agent) => agent.get())
      .then((result) => setVisitorId(result.visitorId))
      .catch(() => {
        // Fallback to crypto.randomUUID if FingerprintJS fails
        setVisitorId(crypto.randomUUID());
        throw new Error(
          "Cannot get your fingerprint, please try reload browser",
        );
      })
      .finally(() => setIsLoading(false));
  }, []);

  return { visitorId, isLoading };
}
